import { comics } from '@/mocks/comics';

export default function ReviewWall() {
  const allReviews = comics.flatMap((comic) =>
    comic.reviews.map((review) => ({
      ...review,
      comicTitle: comic.title,
      comicSlug: comic.slug,
    }))
  ).slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium text-primary-400 uppercase tracking-wider">读者原声</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-50 mb-3">
            漫友们都在说什么
          </h2>
          <p className="text-sm text-foreground-400">
            来自韩漫屋读者的真实评价，看看大家都在追什么漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {allReviews.map((review, index) => (
            <div
              key={review.id}
              className={`bg-background-100 rounded-2xl p-5 border border-background-200/30 transition-all duration-300 hover:border-primary-500/10 ${
                index === allReviews.length - 1 ? 'opacity-70' : ''
              }`}
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-600'}`}
                  ></i>
                ))}
              </div>

              <p className="text-foreground-200 font-semibold text-sm mb-2">{review.title}</p>
              <p className="text-foreground-400 text-xs leading-relaxed mb-4 line-clamp-3">{review.content}</p>

              <div className="flex items-center gap-3 pt-3 border-t border-background-200/30">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={review.userAvatar}
                    alt={review.userName}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-foreground-200 text-xs font-medium">{review.userName}</p>
                  <p className="text-foreground-600 text-[11px]">
                    {review.comicTitle} · {review.date}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}